module.exports = __webpack_public_path__ + "img/envelope_magic_link@2x.656a4c40.png";